
import { defineComponent, onMounted, ref, watch, computed } from "vue";
import { useI18n } from "vue-i18n/index";
import { useRoute, useRouter } from "vue-router";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig from "@/core/config/CleanMainMenuConfig";
import { hasPermissionWrapper } from "@/core/services/permission.service";
import { hasModulePermissionWrapper } from "@/core/services/permission.service";
import { themeDarkLogo } from "@/core/helpers/config";
import { themeLightLogo } from "@/core/helpers/config";
import { useStore } from "vuex";
import { GET_ALL_SITES, SITE_STORE } from "@/store/userSite/types";
import { IOptionModel } from "@/interfaces/iPageModel";
export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);
    const store = useStore();
    const router = useRouter();
    const asideTheme = computed(() => {
      const currentTheme = store.getters.currentTheme;
      return currentTheme === "theme-white" ? "light" : "dark";
    });

    const logoIcon = computed(() => {
      return asideTheme.value === "light"
        ? require("@/assets/media/logos/logoIconDark.png")
        : require("@/assets/media/logos/logoIconWhite.png");
    });

    onMounted(() => {
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    const sitesOptions = computed(() => {
      const key = `${SITE_STORE}/${GET_ALL_SITES}`;
      return store.getters[key] as Array<IOptionModel>;
    });

    const collapseAll = () => {
      let menus = document.querySelectorAll(".side-menu-class");
      menus.forEach((element) => {
        if (!element.classList.contains("collapsed")) {
          element.className = element.className + " collapsed";
        }
      });

      let menuItems = document.querySelectorAll(".site-menu-item-class, .show");
      menuItems.forEach((element) => {
        element.className = element.className.split("show")[0];
      });
    };

    const expandRoutedMenu = () => {
      collapseAll(); // Collapse all menus before expanding the required one

      let menus = document.querySelectorAll<HTMLElement>(".side-menu-class");
      let isMatchingElement: any = null;
      let foundMatch = false;

      // Determine if the route should expand a specific menu
      if (route.path.toLowerCase().includes("/sms")) {
        isMatchingElement = {
          ind: 2,
          index: 2,
          name: "Applications",
          ...MainMenuConfig[2].menus[2],
        };
      } else {
        MainMenuConfig.forEach((section, index) => {
          section.menus.forEach((menu, ind) => {
            if (menu.route.toLowerCase().includes(route.path.toLowerCase())) {
              isMatchingElement = {
                ind: ind,
                index: index,
                name: section.section,
                ...menu,
              };
              foundMatch = true;
              return;
            }
          });
          if (foundMatch) return;
        });
      }

      // Expand the matching menu
      if (isMatchingElement) {
        menus.forEach((element) => {
          const isMatchingRoute = isMatchingElement.route === route.path;
          if (
            isMatchingRoute &&
            element.id
              .toLowerCase()
              .includes(isMatchingElement.name.toLowerCase())
          ) {
            element.classList.remove("collapsed");
            element.click();
          }
        });
      } else {
        // If no match found, do not navigate away
        console.log("No matching menu found for route:", route.path);
      }
    };

    watch(
      () => store.state.SITE_STORE.SELECTED_SITES,
      async (newValue, oldValue) => {
        expandRoutedMenu();
      }
    );
    return {
      hasActiveChildren,
      MainMenuConfig,
      hasPermissionWrapper,
      hasModulePermissionWrapper,
      collapseAll,
      asideMenuIcons,
      version,
      translate,
      themeDarkLogo,
      themeLightLogo,
      asideTheme,
      logoIcon,
      expandRoutedMenu,
      sitesOptions,
    };
  },
});
